import React from 'react';
import { CadreApercu } from './ApercuDocument';

interface DocInfo { id: string; file_name: string; mime_type?: string; }

/**
 * Aperçu du devis signé, affiché DIRECTEMENT dans le panneau de l'étape « Devis envoyé » du pipeline de
 * Suivi de prestation — même composant que DevisSigneApercu.tsx côté Suivi privatisation (code séparé,
 * appelle la route dédiée /prestation-dossiers/:id/documents/:docId), pour ne jamais renvoyer vers une
 * autre section pour vérifier ce que le client a déposé.
 */
export function DevisSigneApercuPrestation({ dossierId, document: doc }: { dossierId: string; document: DocInfo }) {
    const [chargement, setChargement] = React.useState(true);
    const [erreur, setErreur] = React.useState('');
    const [url, setUrl] = React.useState('');

    React.useEffect(() => {
        let annule = false;
        const token = localStorage.getItem('token');
        fetch(`/api/prestation-dossiers/${dossierId}/documents/${doc.id}`, { headers: { Authorization: `Bearer ${token}` } })
            .then((res) => { if (!res.ok) throw new Error('Document introuvable.'); return res.blob(); })
            .then((blob) => { if (!annule) setUrl(URL.createObjectURL(blob)); })
            .catch((e: any) => { if (!annule) setErreur(e?.message || "L'aperçu n'a pas pu être chargé."); })
            .finally(() => { if (!annule) setChargement(false); });
        return () => { annule = true; if (url) URL.revokeObjectURL(url); };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- ne recharger que si le document change
    }, [dossierId, doc.id]);

    const estImage = (doc.mime_type || '').startsWith('image/');
    const estPdf = (doc.mime_type || '').includes('pdf');
    const nonAffichable = !chargement && !erreur && !estImage && !estPdf;

    return (
        <CadreApercu
            titre={doc.file_name}
            url={url}
            estImage={estImage}
            chargement={chargement}
            erreur={erreur || (nonAffichable ? 'Aperçu indisponible pour ce type de fichier.' : '')}
        />
    );
}
